<template>
  <div class="row g-2 align-items-end mb-3">
    <div class="col-md-3">
      <label class="form-label">Status</label>
      <select class="form-select" v-model="filters.status">
        <option value="">Todos</option>
        <option v-for="s in availableStatuses" :key="s" :value="s">
          {{ statusFormat.status(s) }}
        </option>
      </select>
    </div>
    <div class="col-md-3">
      <label class="form-label">Cidade</label>
      <input type="text" class="form-control" v-model="filters.city" placeholder="Buscar cidade" />
    </div>
    <div class="col-md-4">
      <label class="form-label">Cliente</label>
      <input type="text" class="form-control" v-model="filters.client" placeholder="Buscar cliente" />
    </div>
    <div class="col-md-2">
      <button class="btn btn-outline-secondary w-100" @click="$emit('reset')">Limpar</button>
    </div>
  </div>
</template>

<script>
import statusFormat from '@/services/statusFormat';

export default {
  name: 'RentalFilters',
  props: {
    filters: { type: Object, required: true },
    availableStatuses: { type: Array, default: () => [] }
  },
  emits: ['reset'],
  setup() {
    return { statusFormat };
  }
}
</script>